export enum PropertyAssociationAccessLevel
{
    None = 0,
    Guest = 1,
    Adjunct = 2,
}